import React from 'react';
import { DashboardTemplate } from './shared';
import { usageConfig, mockUsageData } from './configs/usage-config';
import { mergeDataWithFallback } from '../../../utils/dataFallback';

function UsageData({ report = {}, loading = false }) {
    // Only use mock data when not loading (to avoid showing mock data before API response)
    const dataWithMock = loading ? report : mergeDataWithFallback(report, mockUsageData);
    
    return (
        <DashboardTemplate 
            title={usageConfig.title}
            topKPIs={usageConfig.topKPIs}
            charts={usageConfig.charts}
            bottomKPIs={usageConfig.bottomKPIs}
            report={dataWithMock}
            loading={loading}
        />
    );
}

export default UsageData;